<script>
import langList from "../utils/lang-list.js";

export default {
  data: () => ({
    langList,
    curLang: {},
  }),

  created() {
    this.getLang(this.$i18n.locale);
  },

  methods: {
    getLang(lang) {
      const curLang = langList.find((x) => x.value == lang);
      if (curLang) {
        this.curLang = curLang;
      } else {
        this.onSelect(langList[0]);
      }
    },

    onSelect(curLang) {
      this.curLang = { ...curLang };
      localStorage.setItem("locale", curLang.value);
      this.$root.$i18n.locale = curLang.value;
    },
  },
};
</script>

<template>
  <v-menu offset-y content-class="locale-dropdown" :nudge-bottom="4" :min-width="160" transition="slide-y-transition">
    <template v-slot:activator="{ on, attrs }">
      <button class="locale-trigger" v-bind="attrs" v-on="on">
        <img :src="curLang.img" alt="" class="locale-flag" />
        <span class="locale-name">{{ $t(curLang.name) }}</span>
        <svg class="locale-chevron" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </template>
    <v-list dense class="locale-list">
      <v-list-item
        v-for="(lang, index) in langList"
        :key="index"
        :disabled="lang.value == curLang.value"
        @click="onSelect(lang)"
        class="locale-item"
      >
        <v-list-item-avatar size="18" class="mr-2 my-0">
          <img :src="lang.img" alt="" />
        </v-list-item-avatar>
        <v-list-item-title class="locale-item-name">{{ $t(lang.name) }}</v-list-item-title>
        <v-icon v-if="lang.value == curLang.value" size="14" class="ml-auto locale-check">mdi-check</v-icon>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<style scoped>
.locale-trigger {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  border-radius: 8px;
  border: 1px solid rgba(0,0,0,.08);
  background: rgba(0,0,0,.03);
  cursor: pointer;
  transition: all .18s ease;
  font-family: inherit;
  font-size: 12px;
  font-weight: 500;
  color: inherit;
  min-width: 0;
}

.locale-trigger:hover {
  background: rgba(0,0,0,.06);
  border-color: rgba(0,0,0,.14);
  box-shadow: 0 2px 8px rgba(0,0,0,.06);
}

.locale-flag {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0 1px 2px rgba(0,0,0,.12);
  flex-shrink: 0;
}

.locale-name {
  font-weight: 600;
  letter-spacing: .01em;
  flex: 1;
}

.locale-chevron {
  width: 10px;
  height: 10px;
}

.locale-chevron {
  opacity: .45;
  transition: opacity .18s ease, transform .18s ease;
  flex-shrink: 0;
}

.locale-trigger:hover .locale-chevron {
  opacity: .75;
}

/* ── scoped list styles (these work because .locale-list is inside the component slot) ── */
.locale-list {
  padding: 4px !important;
  border-radius: 10px !important;
  min-width: 140px !important;
}

.locale-item {
  border-radius: 6px !important;
  min-height: 32px !important;
  padding: 0 10px !important;
  transition: background .12s ease;
}

.locale-item-name {
  font-size: 12px !important;
  font-weight: 500 !important;
  letter-spacing: .01em !important;
}

/* ── Dark mode (trigger only — dropdown styles are global in App.vue) ── */
.theme--dark .locale-trigger {
  border-color: rgba(255,255,255,.08);
  background: rgba(255,255,255,.04);
  color: #e4e5eb;
}

.theme--dark .locale-trigger:hover {
  background: rgba(255,255,255,.08);
  border-color: rgba(255,255,255,.14);
  box-shadow: 0 2px 8px rgba(0,0,0,.2);
}

.theme--dark .locale-chevron {
  color: #8b8d9e;
}
</style>
